/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chapter_ComingInputs */

const en_chapter_coming = /** @type {(inputs: Chapter_ComingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming`)
};

/**
* | output |
* | --- |
* | "Coming" |
*
* @param {Chapter_ComingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chapter_coming = /** @type {((inputs?: Chapter_ComingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chapter_ComingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_chapter_coming(inputs)
});